// Проверяет, является ли URL внутренней ссылкой на домены smart.swnn.ru или swnn.ru
export const isInternalUrl = (url: string): boolean => {
  if (!url) return false;
  
  try {
    const urlObj = new URL(url);
    const hostname = urlObj.hostname.toLowerCase();
    return hostname === 'smart.swnn.ru' || hostname === 'swnn.ru' || hostname === 'www.smart.swnn.ru' || hostname === 'www.swnn.ru';
  } catch {
    // Если не удается распарсить как URL, считаем внутренней ссылкой
    return true;
  }
};

// Извлекает путь из внутренней ссылки
export const getPath = (url: string): string => {
  if (!url) return url;
  
  // Если это внутренняя ссылка с доменом
  if (isInternalUrl(url) && (url.includes('http://') || url.includes('https://'))) {
    try {
      const urlObj = new URL(url);
      return urlObj.pathname + urlObj.search + urlObj.hash;
    } catch {
      return url;
    }
  }
  
  // Если это относительный путь или уже обработанный путь
  return url;
};

// Открывает внешнюю ссылку в новом окне
export const openExternalUrl = (url: string): void => {
  window.open(url, '_blank', 'noopener,noreferrer');
};